import React, { useRef } from "react";
import styled from "styled-components";
import { NavigateBefore as NavigateBeforeIcon, NavigateNext as NavigateNextIcon, MoreHoriz as MoreHorizIcon } from "@mui/icons-material";

const MobilePortraitNavigation = styled.div`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  pointer-events: none;
`;

const NavigationContainer = styled.div`
  padding: 4px; 
  background: #222222; 
  border-radius: 100px; 
  flex-direction: row; 
  justify-content: flex-start; 
  align-items: flex-start; 
  gap: 10px; 
  display: inline-flex;
  pointer-events: auto;
  align-items: center;
`;

const SlideCounterText = styled.div`
  color: white;
  font-size: 16px;
  font-weight: 400;
  white-space: nowrap;
  text-align: center;
  font-family: Source Sans Pro;
`;

const NavigationButton = styled.button`
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 4px;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.7;
  }
  
  &:active {
    opacity: 0.5;
  }
  
  svg {
    color: white;
    font-size: 20px;
  }
`;

const MobileLandscapeLeftArrow = styled.button`
  position: fixed;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 80px;
  height: 100%;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1000;

  svg {
    color: white;
    font-size: 48px;
  }
`;

const SlideCounterContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MobileLandscapeRightPanel = styled.div`
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 80px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const MobileLandscapeRightArrow = styled.button`
  flex: 1;
  width: 100%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: transparent;

  svg {
    color: white;
    font-size: 48px;
  }
`;

const ThreeDotsMenuButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  /* needs to be on top of the navigation buttons */
  z-index: 1001;
  background: transparent;
  
  svg {
    color: white;
    font-size: 24px;
  }
`;

function PlayerNavigationButtons({
    isMobileOrTablet,
    isMobileLandscape,
    currentSlideIndex,
    presentation,
    skippedSlideIds,
    onAdvanceToSlide,
    onTrackSlideNavigation,
    onOpenMenu,
    menuAnchorEl
}) {
    const menuButtonRef = useRef(null);

    if (!isMobileOrTablet || window.isZoomApp) {
        return null;
    }

    const handleNavigate = direction => {
        onAdvanceToSlide(direction);
        onTrackSlideNavigation({ method: "buttons", deviceType: "mobile" });
    };

    const handleMenuClick = () => {
        if (onOpenMenu) {
            onOpenMenu(menuButtonRef.current || menuAnchorEl);
        }
    };

    const slidesCount = presentation.getSips(skippedSlideIds).length;

    return (
        <>
            {isMobileLandscape && (
                <>
                    <MobileLandscapeLeftArrow
                        onClick={() => handleNavigate(-1)}
                    >
                        <NavigateBeforeIcon />
                    </MobileLandscapeLeftArrow>
                    <MobileLandscapeRightPanel>
                        <MobileLandscapeRightArrow
                            onClick={() => handleNavigate(1)}
                        >
                            <NavigateNextIcon />
                        </MobileLandscapeRightArrow>
                        <ThreeDotsMenuButton
                            ref={menuButtonRef}
                            onClick={handleMenuClick}
                        >
                            <MoreHorizIcon />
                        </ThreeDotsMenuButton>
                    </MobileLandscapeRightPanel>
                </>
            )}
            {!isMobileLandscape && (
                <MobilePortraitNavigation>
                    <NavigationContainer>
                        <NavigationButton
                            onClick={() => handleNavigate(-1)}
                        >
                            <NavigateBeforeIcon />
                        </NavigationButton>
                        <SlideCounterContainer>
                            <SlideCounterText>
                                {currentSlideIndex + 1} of {slidesCount}
                            </SlideCounterText>
                        </SlideCounterContainer>
                        <NavigationButton
                            onClick={() => handleNavigate(1)}
                        >
                            <NavigateNextIcon />
                        </NavigationButton>
                    </NavigationContainer>
                </MobilePortraitNavigation>
            )}
        </>
    );
}

export default PlayerNavigationButtons;

